export default __webpack_public_path__ + "static/media/check-unscreen.4298535e.gif";